import axios from "axios";
import { getToken } from "./auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  }
  return config;
});

api.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 401) {
    localStorage.setItem("@adminModulockerCond:error", "expired");
  }
  if (error?.response?.status === 500) {
    localStorage.setItem("@adminModulockerCond:error", "error");
  }
  return Promise.reject(error);
});

export default api;
